import React from 'react'

import {
  View,
  StyleSheet,
  ActivityIndicator,
} from 'react-native';

import {useFocusEffect, useIsFocused} from '@react-navigation/native';
import { Text } from 'react-native';
import ProjectApi from '../../services/modules/project/api';
import Colors from '../../constants/Colors';
import { TraxxText } from '../ui/TraxxText';

interface Props {
}

const StatsTicker: React.FC<Props> = ({ 
}) => {   
  const isFocused = useIsFocused()

  const [totalCompleted, setTotalCompleted] = React.useState(0);
  const [totalInProgress, setTotalInProgress] = React.useState(0);
  const [totalWeight, setTotalWeight] = React.useState(0);
  const [totalOverallCompleted, setTotalOverallCompleted] = React.useState(0);
  const [totalOverallWeight, setTotalOverallWeight] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  
  const init = () => {
    setLoading(true);

    ProjectApi.myStatsToday()
    .then((apiResponse: any) => {
      setTotalCompleted(apiResponse.data.complete);
      setTotalInProgress(apiResponse.data.inProgress);
      setTotalWeight(apiResponse.data.weight);
      setLoading(false);
    });

    ProjectApi.stats()
    .then((apiResponse: any) => {
      setTotalOverallCompleted(apiResponse.data.complete);
      setTotalOverallWeight(apiResponse.data.weight);
      setLoading(false);
    });
  }

  useFocusEffect (
    React.useCallback(() => {      
      if (isFocused) {
        init();
      }
    }, [isFocused])
  );

  return (<View>       
    {loading &&
      <View style={{marginTop: 40}}>
        <ActivityIndicator size="large" color="#3F51B5" />
        <TraxxText style={styles.loadingText}>Loading...</TraxxText>
      </View>
    }
    {!loading && <View>    
      <View style={styles.componentContainer}>            
        <View style={styles.sectionHeaderView}>
          <TraxxText style={styles.sectionHeader}>HAULS TODAY</TraxxText>
        </View>
        <View style={styles.container}>
          <View style={styles.statsContainer50}>
            <TraxxText style={styles.statsHeader}>In Progress</TraxxText>
            <TraxxText style={styles.stat}>{totalInProgress}</TraxxText>
          </View>
          <View style={styles.statsContainer50}>
            <TraxxText style={styles.statsHeader}>Completed</TraxxText>
            <TraxxText style={styles.stat}>{totalCompleted}</TraxxText>
          </View>
        </View>
        <View style={styles.container}>
          <View style={[styles.statsContainer100,{marginBottom: 10}]}>
            <TraxxText style={styles.statsHeader}>Total Weight</TraxxText>
            <TraxxText style={styles.stat}>{totalWeight} Cu. Meters</TraxxText>
          </View>
        </View>       
      </View>
      <View style={[styles.componentContainer, {marginTop: "2%"}]}>    
        <View style={styles.sectionHeaderView}>
          <TraxxText style={styles.sectionHeader}>ALL HAULS</TraxxText>
        </View>
        <View style={styles.container}>
          <View style={styles.statsContainer50}>
            <TraxxText style={styles.statsHeader}>Completed</TraxxText>
            <TraxxText style={styles.stat}>{totalOverallCompleted}</TraxxText>
          </View>
          <View style={styles.statsContainer50}>
            <TraxxText style={styles.statsHeader}>Total Weight</TraxxText>
            <TraxxText style={styles.stat}>{totalOverallWeight}</TraxxText>
            <TraxxText style={styles.statsHeader}>Cu. Meters</TraxxText>
          </View>
        </View>
      </View>
    </View>}
  </View>
  )
};

const styles = StyleSheet.create({ 
  stat: {
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  statsHeader: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  statsContainer50: {
    width: "50%",
  },
  statsContainer100: {
    width: "100%",
  },
  sectionHeader: {
    fontWeight: 'bold',
    fontSize: 20,
    flex: 1,
    textAlign: 'center',
    marginBottom: 10,
  },
  sectionHeaderView: {
    flexDirection: 'row',
  },
  componentContainer: {   
    backgroundColor: Colors.white, 
    padding: "1%",
    borderColor: Colors.borderGrey,
    borderWidth: 1,
    borderRadius: 10,
    width: "100%"
  },
  loadingText: {
    textAlign: 'center',
    padding: 10,
    fontWeight: 'bold'
  },
  container: {
    flexDirection: 'row',
    padding: 10,
  },
});
export default StatsTicker